module.exports = __webpack_public_path__ + "img/hr-defender-robot-shadow.f7502f47.png";